function initIndustrialHeader() {
  const header = document.querySelector('[data-site-header]');
  const adminBar = document.getElementById('wpadminbar');

  if (!header) {
    return;
  }

  const SCROLL_SOLID_ON = 26;
  const SCROLL_SOLID_OFF = 10;

  let isSolid = window.scrollY > SCROLL_SOLID_ON;
  let rafId = 0;

  const applyHeaderState = (solid) => {
    header.classList.toggle('is-scrolled', solid);
  };

  const syncHeaderTopOffset = () => {
    if (!(adminBar instanceof HTMLElement)) {
      header.style.top = '0px';
      return;
    }

    const adminBarStyle = window.getComputedStyle(adminBar);
    if (adminBarStyle.display === 'none' || adminBarStyle.visibility === 'hidden') {
      header.style.top = '0px';
      return;
    }

    const adminBarRect = adminBar.getBoundingClientRect();
    const adminBarOffset = adminBarRect.bottom > 0 ? Math.round(adminBarRect.bottom) : 0;
    header.style.top = `${adminBarOffset}px`;
  };

  const queueHeaderPaint = () => {
    if (rafId) {
      return;
    }

    rafId = window.requestAnimationFrame(() => {
      rafId = 0;
      syncHeaderTopOffset();
      const forcedSolid = header.classList.contains('is-mega-active');
      applyHeaderState(forcedSolid || isSolid);
    });
  };

  const toggleScrolledState = () => {
    const y = window.scrollY;

    if (!isSolid && y >= SCROLL_SOLID_ON) {
      isSolid = true;
    } else if (isSolid && y <= SCROLL_SOLID_OFF) {
      isSolid = false;
    }

    queueHeaderPaint();
  };

  const handleResize = () => {
    queueHeaderPaint();
  };

  queueHeaderPaint();
  window.addEventListener('scroll', toggleScrolledState, { passive: true });
  window.addEventListener('resize', handleResize, { passive: true });

  document.addEventListener(
    'turbo:before-cache',
    () => {
      window.removeEventListener('scroll', toggleScrolledState);
      window.removeEventListener('resize', handleResize);
      if (rafId) {
        window.cancelAnimationFrame(rafId);
      }
    },
    { once: true }
  );
}

initIndustrialHeader();
document.addEventListener('turbo:load', initIndustrialHeader);
